import {throttleEvent} from "../module/throttle-event.function";

export class MenuScrollClass {
    private scrollBreakpoint: number;
    private readonly scrollBreakpointBase: number;
    private readonly doc = document.documentElement;
    private readonly activeClass = 'is-header-sticky';

    private readonly gap = 68;

    private isActive = false;

    private readonly scrollableRoot = document.querySelector('.js-window-scroll');

    constructor() {
        if (!this.doc.classList.contains(this.activeClass)) {
            this.scrollBreakpointBase =  document.querySelector('.site-banner__img').getBoundingClientRect().height;
            this.updateScrollBreakpoint();
            this.init();
        }
    }

    private updateScrollBreakpoint() {
        this.scrollBreakpoint = this.scrollBreakpointBase + (this.gap * (this.isActive ? 1 : -1));
    }

    private init(): void {
        const scrollListener = throttleEvent(() => {
            this.handleFixedClass();
        }, 150);

        this.scrollableRoot.addEventListener('scroll', scrollListener);
        this.handleFixedClass();
    }

    private handleFixedClass(): void {
        const oldState = this.isActive;
        this.isActive = this.scrollableRoot.scrollTop > this.scrollBreakpoint;

        if (oldState !== this.isActive) {
            this.doc.classList.toggle(this.activeClass, this.isActive);
        }

        if (!this.isNoMansLand()) {
            this.updateScrollBreakpoint();
        }
    }

    /**
     * Whether user scrolling in is scrollbreakpoint +- gap
     * @private
     */
    private isNoMansLand(): boolean {
        return this.scrollableRoot.scrollTop > this.scrollBreakpointBase - this.gap &&
                this.scrollableRoot.scrollTop < this.scrollBreakpointBase + this.gap;
    }
}
